import { coreState, coreMutations, coreActions, coreGetters } from '~/marketplace-front-core/store/websocket'
export const state = coreState
export const mutations = coreMutations
export const actions = coreActions
export const getters = coreGetters
